export default "__VITE_ASSET__Dwcd54he__"